import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PropTypes from 'prop-types';

const AAFModalCheckEmail = (props = {}) => {
  let title = Translator.get('sendLink_modal_title_label','Revisa tu bandeja de entrada o tu correo no deseado');
  const content = Translator.get('sendLink_modal_description_label','Te enviamos un correo electrónico con el link para iniciar sesión a');
  title = title.replace('{@EMAIL}', '<br>' +props.email +'</b>');
  const p = {
    content,
    title,
    replaces: { '{@EMAIL}': props.email },
    alwaysEnabled: true,
    buttons: [
      {
        content: Translator.get('sendLink_modal_option_button_close', 'Entendido'),
        props: {
          onClick: (e) => {props.handleClose(e, props.callback);},
          className: 'aaf-modal-button aaf-modal-button-primary'
        }
      }
    ],
    aafNewStyle: true,
    className: 'aaf-modal-password',
  };
  return <ModalWrapper {...p} />;
};

AAFModalCheckEmail.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};

export default withOnClose(AAFModalCheckEmail);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalCheckEmail.jsx